import React, { useState } from 'react'
import ProductCard from "../ProductCard";

function ProductList({products,gridClass}) {

    const [visibleProducts, setVisibleProducts] = useState(10);

    const handleShowMore = () => {
        setVisibleProducts(prevVisibleProducts => prevVisibleProducts + 10); // Show 10 more products
      };

  return (
    <section id="all-prodcuts" className="mt-2">
    <div className={`justify-center container gap-4 grid p-2 ${gridClass}`}>
    {products.slice(0, visibleProducts).map((product, index) => {
        return <ProductCard key={product.id} product={product} productCss="w-full p-2"/>
    })}
    
  </div>
  <div className="flex justify-center items-center my-4 px-6 show-more-btn show-more-btn w-full">
   
    <button className="hover:shadow-lg px-4 p-3 border hover:font-bold text-[12px] text-primary capitalize" onClick={handleShowMore} style={{letterSpacing:'1px'}}>Show More</button>

    </div>
</section>
  )
}

export default ProductList